import rectLoading from './rectLoading'
import debounce from './debounce'
import throttle from './throttle'

export default [
  debounce,
  throttle,
  rectLoading
]
